import m from 'mithril'
import stream from 'mithril/stream'
import moment from 'moment'
import {
    Dialog,
    TextBox,
    TextArea,
    Editor,
} from 'components'
import classNames from 'classnames'
import {
    Article
} from "app/models"

class EditComponent {
    constructor(vnode) {
        this.articles = []
        Article.fetchList().then((_resposne) => {
            this.articles = _resposne
        })
        if (vnode.attrs.model == null || vnode.attrs.model == "") {

        } else {

        }
    }
    save() {
        Dialog.close(this.model)
    }
    close(event) {
        this._close(event)
    }
    _close(value) {
        setTimeout(() => {
            Dialog.close(value)
            m.redraw()
        }, 200)
    }
    view(vnode) {
        return [m(".modal-dialog.modal-dialog-centered[role='document']", [
            m(".modal-content",
                [
                    m(".modal-header",
                        [
                            m("h5.modal-title", "編輯屬性"),
                            m("button.close", {
                                onclick: (e) => {
                                    e.preventDefault()
                                    this.close()
                                }
                            },
                                m("span", m.trust("&times;"))
                            ),
                        ]
                    ),
                    m(".modal-body",
                        m(".row.w-100", [
                            m("label.text-light.mb-1.badge-info.px-3", "分享種類"),
                            m('.col-12.d-flex.align-items-center.py-2', [
                                m(".px-4", [
                                    m(".form-radio.form-radio-flat.my-2",
                                        m("label.form-check-label.pl-4",
                                            [
                                                m("input.form-check-input[type='radio']", {
                                                    checked: vnode.attrs.model.is_customer,
                                                    style: "color:#000",
                                                    onclick: () => {
                                                        vnode.attrs.model.is_customer = !vnode.attrs.model.is_customer
                                                    }
                                                }), "顧客",
                                                m("i.input-helper")
                                            ]
                                        )
                                    ),
                                ]),
                                m(".px-4", [
                                    m(".form-radio.form-radio-flat.my-2",
                                        m("label.form-check-label.pl-4",
                                            [
                                                m("input.form-check-input[type='radio']", {
                                                    checked: vnode.attrs.model.is_master,
                                                    style: "color:#000",
                                                    onclick: () => {
                                                        vnode.attrs.model.is_master = !vnode.attrs.model.is_master
                                                    }
                                                }),
                                                "師傅",
                                                m("i.input-helper")
                                            ]
                                        )
                                    ),
                                ])
                            ]),

                            m("label.text-light.mb-1.badge-info.px-3", "連結種類"),

                            m('.col-12.d-flex.align-items-center.py-2', [

                                m(".px-4", [
                                    m(".form-radio.form-radio-flat.my-2",
                                        m("label.form-check-label.pl-4",
                                            [
                                                m("input.form-check-input[type='radio']", {
                                                    checked: vnode.attrs.model.type == "blog",
                                                    style: "color:#000",
                                                    onclick: () => {
                                                        vnode.attrs.model.type = "blog"
                                                    }
                                                }), "部落格",
                                                m("i.input-helper")
                                            ]
                                        )
                                    ),
                                ]),
                                m(".px-4", [
                                    m(".form-radio.form-radio-flat.my-2",
                                        m("label.form-check-label.pl-4",
                                            [
                                                m("input.form-check-input[type='radio']", {
                                                    checked: vnode.attrs.model.type == "outside",
                                                    style: "color:#000",
                                                    onclick: () => {
                                                        vnode.attrs.model.type = "outside"
                                                    }
                                                }),
                                                "外部",
                                                m("i.input-helper")
                                            ]
                                        )
                                    ),
                                ])
                            ]),
                            (vnode.attrs.model.type == "blog") ? [
                                m(".col-12", [
                                    m(".form-group", [
                                        m("label.text-dark.mb-1", "欲連結部落格Id"),
                                        [
                                            m('select.form-control', {
                                                onchange: (e) => {
                                                    vnode.attrs.model.type_id = e.target.value
                                                }
                                            }, [
                                                m('option'),
                                                this.articles.map((item) => {
                                                    return m('option', {
                                                        selected: vnode.attrs.model.type_id == item.id,
                                                        value: item.id
                                                    }, item.title)
                                                })
                                            ])
                                        ]
                                    ]),
                                ])] : "",
                            (vnode.attrs.model.type == "outside") ? [

                                m(".col-12", [
                                    m(".form-group", [
                                        m("label.text-dark.mb-1", "外部連結-請填入完整地址"),
                                        [
                                            m(TextBox, {
                                                oninput: (e) => {
                                                    vnode.attrs.model.outside_url = e.target.value
                                                },
                                                class: 'mt-0 form-control',
                                                value: vnode.attrs.model.outside_url,
                                                type: 'text',
                                            })
                                        ]
                                    ]),
                                ]),
                            ] : "",
                        ]),
                    ),
                    m(".modal-footer",
                        [
                            // m("button.btn.btn-label.rounded", {
                            //     onclick: (e) => {
                            //         e.preventDefault()
                            //         this.close()
                            //     }
                            // },
                            //     [m("i.fa.fa-times-circle"), "關閉"]
                            // ),
                            m("button.btn.btn-primary[type='button']", {
                                onclick: (e) => {
                                    e.preventDefault()
                                    this.save()
                                }
                            },
                                [
                                    m("i.fa.fa-check-circle"),
                                    m("span.pl-2", "確認")
                                ])
                        ],
                    )
                ]
            )
        ])]
    }
}

export default EditComponent
